import { lazy } from 'react';

export const LingobotPage = lazy(() => import('./Page'));
